<template>
  <div v-if="electionPeriod">
    <icon-router-link icon="chevron-left" to="/pk/forside">Tilbake</icon-router-link>
    <div class="uppercase font-bold text-gray-500 mt-6">Valgperiode: {{ electionPeriod.name }}</div>
    <div class="flex justify-between items-center mb-4">
      <h1 class="text-4xl font-bold tracking-tight text-gray-600">Praksisperioder</h1>
      <div class="flex items-center">
        <router-link class="ml-6 btn btn-primary" to="praksisperioder/opprett">Ny praksisperiode</router-link>
        <a href="#" @click.prevent="onDelete" class="ml-4 btn btn-primary" v-if="selected.length > 0">
            <font-awesome-icon :icon="['far', 'trash']" />
          </a>
      </div>
    </div>
    <panel class="p-4">
      <data-table
      :headers="headers"
      :items="practicePeriods"
      :showSelect="true"
      v-model="selected"
      identifier="practicePeriodId"
      @click="onClick">
    </data-table>
    </panel>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'pk-practiceperiod-list',
  data () {
    return {
      search: '',
      headers: [
        { text: 'Navn', align: 'left', value: 'name' },
        { text: 'Studie', align: 'left', value: 'studyDisplay' },
        { text: 'Fra', align: 'left', value: 'fromDisplay' },
        { text: 'Til', align: 'left', value: 'toDisplay' },
      ],
      practicePeriods: [],
      electionPeriod: null,
      selected: [],
    }
  },
  methods: {
    onClick (practicePeriod) {
      this.$router.push({ name: 'pk-practiceperiod-edit', params: { id: practicePeriod.practicePeriodId } })
    },
    async onDelete () {
      for (let i = 0; i < this.selected.length; i++) {
        await api.pk.deletePracticePeriod(this.selected[i].practicePeriodId)
      }
      this.practicePeriods = await api.pk.getPracticePeriods()
    }
  },
  async created () {
     this.electionPeriod = await api.pk.getElectionPeriod()
     this.practicePeriods = await api.pk.getPracticePeriods()
   }
}
</script>